/* Copyright (c) 2016-2023 Planticle Pty Ltd */
"use strict";

import ko from "knockout";
import birdata from "../api.js";
import util from "../util/util.js";
import moment from "dayjs";

var HomeStatsViewModel = function(params) {
	var self = this;

	self.timePeriodOptions = [
		{
			title: 'In the past month',
			value: 'month'
		},
		{
			title: 'In the past year',
			value: 'year'
		}
	];
	self.timePeriod = ko.observable(self.timePeriodOptions[0]);

	self.loading = ko.observable(true);

	self.ibaStats = ko.observable();
	self.sharedSiteStats = ko.observable();
	self.threatenedSpeciesStats = ko.observable();
	self.activeObservers = ko.observable();
	self.topObservers = ko.observable();

	ko.computed(function() {
		var criteria = {
			from: moment().subtract(1, self.timePeriod().value).format("YYYY-MM-DD"),
			to: moment().format("YYYY-MM-DD"),
			_options: { public: true }
		};

		self.loading(true);

		Promise.all([
			birdata.stats("area_layer/iba/surveys", criteria),
			birdata.stats("shared_site_layer/all/surveys", criteria),
			birdata.stats("threatened_species", criteria),
			birdata.stats("active_observers", criteria)
		]).then(function([ibas, sharedSites, threatenedSpecies, activeObservers]) {
				self.ibaStats(util.formatNumber(ibas.surveyed_areas) + " / " + util.formatNumber(ibas.total_areas));
				self.sharedSiteStats(util.formatNumber(sharedSites.surveyed_shared_sites) + " / " + util.formatNumber(sharedSites.total_shared_sites));
				self.threatenedSpeciesStats(util.formatNumber(threatenedSpecies.sighted_threatened_species) + " / " + util.formatNumber(threatenedSpecies.total_threatened_species));
				self.activeObservers(util.formatNumber(activeObservers.active_observers));
				self.topObservers(activeObservers.top_observers);
				self.loading(false);
			});
	});
};


ko.components.register('home-stats', {
	viewModel: function(params) {
		return new HomeStatsViewModel(params);
	},
	template: require('../../templates/home-stats.html')
});

export default HomeStatsViewModel;
